export const footerContactInfos = [
  {
    title: "capitais e regiões metropolitanas",
    tel: "4004 4828"
  },
  {
    title: "demais localidades",
    tel: "0800 970 4828"
  }
]
